@let commonData = commonDataService.getData() | async;
@let helpCenterPhone = commonData?.helpCenterPhone; @let agentPhone = salesAgent?.phone;
@let agentName = salesAgent?.fullName;

<div class="d-flex align-items-center">
  <img src="/assets/icons/help.svg" alt="help" width="24" height="24" />
  <h3 class="semi-bold ml-2">Need help? We're just a call away!</h3>
</div>

@if (agentPhone && agentName) {
  <p class="mt-2">
    We want to make sure your trip is perfect from start to finish. If you need any help, please
    feel free to call {{ agentName }} anytime at
    <a href="tel:{{ agentPhone | phone }}" class="link text-sun-crete-800">
      {{ agentPhone | phone }}</a
    >.
    <br class="d-md-none" />
    @if (helpCenterPhone) {
      Need anything else? Our general support line is available at
      <a class="text-sun-crete-800" href="tel:{{ helpCenterPhone | phone }}">
        {{ helpCenterPhone | phone }}</a
      >.
    }
  </p>
} @else if (helpCenterPhone) {
  <p class="mt-2">
    We want to make sure your trip is perfect from start to finish. If you need any help, please
    feel free to call us anytime at
    <a href="tel:{{ helpCenterPhone | phone }}" class="link text-sun-crete-800">
      {{ helpCenterPhone | phone }}</a
    >.
    <br class="d-md-none" />
    We're always here for you, just a phone call away.
  </p>
}
